module.exports = __webpack_public_path__ + "static/img/aepic-27.b9f4789.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/aepic/aepic-27.jpg
// module id = HqxK
// module chunks = 51